import React, { useEffect, useState } from "react";
import { api, imgSrc } from "../lib/api";
import PodcastPlayer from "../components/PodcastPlayer";
import MarqueeStrip from "../components/MarqueeStrip";

export default function PodcastPage() {
  const [episodes, setEpisodes] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/podcast/episodes", { params: { limit: 50 } }).then((r) => setEpisodes(r.data));
    api.get("/settings").then((r) => setSettings(r.data));
  }, []);

  const latest = episodes[0];

  return (
    <div data-testid="podcast-page">
      <section className="bg-[#FA6157] border-b-2 border-black">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-20">
          <p className="pill-tag bg-[#FFD01E] mb-5">Nouveau chaque vendredi</p>
          <h1 className="font-display-black text-6xl sm:text-8xl lg:text-[10rem] leading-none">
            LE PODCAST
            <br />
            <span className="text-[#FFFDF7]">qui dit tout.</span>
          </h1>
        </div>
      </section>

      {latest && <PodcastPlayer episode={latest} settings={settings} />}

      <MarqueeStrip items={["TOUS LES VENDREDIS", "À 8H", "DU MATIN"]} bg="#FFD01E" color="#050505" />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16">
        <h2 className="font-display-black text-4xl sm:text-6xl mb-8">Archives</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {episodes.slice(1).map((ep) => (
            <div
              key={ep.id}
              data-testid={`episode-${ep.number}`}
              className="brutal-card overflow-hidden"
            >
              <div className="aspect-[5/4] overflow-hidden border-b-2 border-black">
                <img src={imgSrc(ep.cover_image)} alt={ep.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <p className="text-xs uppercase font-bold tracking-widest text-black/60">
                  Épisode #{ep.number} · {ep.duration}
                </p>
                <h3 className="font-display text-2xl mt-1">{ep.title}</h3>
                <p className="text-sm text-black/70 mt-2 line-clamp-2">{ep.description}</p>
                <div className="mt-4 flex gap-2 flex-wrap">
                  <a href={ep.spotify_url} target="_blank" rel="noreferrer" className="pill-tag bg-[#0A8074] text-white">
                    Spotify
                  </a>
                  <a href={ep.apple_url} target="_blank" rel="noreferrer" className="pill-tag bg-[#D9C5FD]">
                    Apple
                  </a>
                  <a href={ep.deezer_url} target="_blank" rel="noreferrer" className="pill-tag bg-[#FFD01E]">
                    Deezer
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
